<template>
  <el-dialog title="新增顾客LEVEL配置"
             :visible.sync="dialogVisible"
             custom-class="importDialog"
             @close="hide"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             v-loading="loading"
             ref="refDialog"
             label-width="100px">
      <el-row>

        <el-col :span="12">
          <el-form-item prop="business"
                        label="商家">
            <el-input clearable
                      disabled
                      v-model="form.business"
                      placeholder="请选择"
                      style="width: 100%">

            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="store"
                        label="店铺">
            <el-input clearable
                      disabled
                      v-model="form.store"
                      placeholder="请选择"
                      style="width: 100%">

            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- <el-form-item prop="month"
                        label="R值(月)">
            <el-input v-model="form.month"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      :min="1"
                      :max="99"></el-input> -->
          <!-- <el-select clearable
                       disabled
                       v-model="form.store"
                       placeholder="请选择"
                       style="width: 90%"> -->

          <!-- </el-form-item> -->
          <el-form-item prop="month"
                        label="R值(月)">
            <el-select clearable
                       v-model="form.month"
                       placeholder="请选择R值..."
                       style="width: 100%">
              <el-option v-for="item in [{'name':'3个月','value':3},{'name':'6个月','value':6},{'name':'12个月','value':12}]"
                         :key="item.value"
                         :label="item.name"
                         :value="item.value">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="level"
                        label="顾客属性">
            <el-select clearable
                       v-model="form.level"
                       placeholder="请选择">
              <el-option v-for="item in level_list"
                         :key="item.label"
                         :label="item.value"
                         :value="item.value"
                         :disabled="item.disabled">{{ item.label }}</el-option>
            </el-select>
            <!-- <el-select clearable
                       v-model="form.level"
                       placeholder="输入level"
                       style="width: 100%">

              <el-option v-for="item in level_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
                         :disabled="item.disabled">
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="count"
                        label="count">
            <el-input clearable
                      oninput="value=value.replace(/[^\d]/g,'')"
                      v-model="form.count"
                      placeholder="输入count"
                      :min="1">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="money"
                        label="money">
            <el-input clearable
                      oninput="value=value.replace(/[^\d]/g,'');value=value.replace(/^0+(\d)/,'$1');"
                      v-model="form.money"
                      :min="1"
                      placeholder="输入money">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- <div class="add-button"> -->
          <el-divider>
            <el-button plain
                       type="primary"
                       @click="addItem()">添 加</el-button>
          </el-divider>

          <!-- </div> -->
        </el-col>
      </el-row>
    </el-form>
    <el-col class="table-botton">

      <el-table :data="levelData"
                :header-cell-style="{ 'text-align': 'center !important' }">
        <el-table-column prop="level"
                         label="顾客属性"
                         max-width="180"
                         align="center">
        </el-table-column>
        <el-table-column prop="count"
                         label="R值"
                         align="center"
                         max-width="180">
        </el-table-column>
        <el-table-column prop="money"
                         label="M值"
                         align="center"
                         max-width="180">
        </el-table-column>
        <el-table-column label="操作"
                         align="center">
          <template slot-scope="scope">
            <div>
              <el-link icon="el-icon-delete"
                       type="danger"
                       :underline="false"
                       @click="removeRow(levelData,scope.row)">删除</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary"
                 v-loading="loading"
                 @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
import { rules } from './data.js'
let _rule = JSON.parse(JSON.stringify(rules))
import * as Desc from './desc.js'
import { dealReturn } from '@/common/js'

export default {
  // mixins: [getplatlists, getptnlists, getshoplists],
  props: { queryInfo: Object },

  data() {
    return {
      dialogVisible: false,
      query: this.queryInfo,
      form: {
        profession: '',
        business: '',
        store: '',
        month: '',
        level: '',
        count: 1,
        money: 1,
      },
      loading: false,
      loading: false,
      levelData: [],
      rules: _rule,
      Desc,

      level_list: [
        {
          value: 'A',
          label: 'A',
          disabled: false,
        },
        {
          value: 'B',
          label: 'B',
          disabled: false,
        },
        {
          value: 'C',
          label: 'C',
          disabled: false,
        },
        {
          value: 'D',
          label: 'D',
          disabled: false,
        },
        {
          value: 'E',
          label: 'E',
          disabled: false,
        },
        {
          value: 'F',
          label: 'F',
          disabled: false,
        },
        {
          value: 'G',
          label: 'G',
          disabled: false,
        },
        {
          value: 'H',
          label: 'H',
          disabled: false,
        },
        {
          value: 'I',
          label: 'I',
          disabled: false,
        },
        {
          value: 'J',
          label: 'J',
          disabled: false,
        },
        {
          value: 'K',
          label: 'K',
          disabled: false,
        },
        {
          value: 'L',
          label: 'L',
          disabled: false,
        },
        {
          value: 'M',
          label: 'M',
          disabled: false,
        },
        {
          value: 'N',
          label: 'N',
          disabled: false,
        },
        {
          value: 'O',
          label: 'O',
          disabled: false,
        },
        {
          value: 'P',
          label: 'P',
          disabled: false,
        },
        {
          value: 'Q',
          label: 'Q',
          disabled: false,
        },
        {
          value: 'R',
          label: 'R',
          disabled: false,
        },
        {
          value: 'S',
          label: 'S',
          disabled: false,
        },
        {
          value: 'T',
          label: 'T',
          disabled: false,
        },
        {
          value: 'U',
          label: 'U',
          disabled: false,
        },
        {
          value: 'V',
          label: 'V',
          disabled: false,
        },
        {
          value: 'W',
          label: 'W',
          disabled: false,
        },
        {
          value: 'X',
          label: 'X',
          disabled: false,
        },
        {
          value: 'Y',
          label: 'Y',
          disabled: false,
        },
        {
          value: 'Z',
          label: 'Z',
          disabled: false,
        },
      ],
    }
  },
  methods: {
    changeLevel() {
      console.log(this.levelData)
      this.level_list.forEach((v) => {
        v.disabled = false
        // console.log(v.value)
        for (var i = 0; i < this.levelData.length; i++) {
          // console.log(this.levelData[i].level)
          if (this.levelData[i].level == v.value) {
            // console.log('===============')
            // console.log(v)
            v.disabled = true
          }
        }
      })
      console.log(this.level_list)
    },
    removeRow(data, row) {
      console.log('row', row)
      console.log('data', data)
      var index = data.indexOf(row)
      console.log('index', index)
      if (index !== -1) {
        data.splice(index, 1)
      }
      this.changeLevel()
    },
    addItem() {
      if (!this.form.level) {
        this.$message({
          showClose: true,
          message: 'level必填',
          type: 'error',
          duration: 1000,
        })
        // this.$message.error()
        return
      }
      if (!this.form.count) {
        this.$message({
          showClose: true,
          message: 'count必填',
          type: 'error',
          duration: 1000,
        })
        // this.$message.error('')
        return
      }
      if (!this.form.money) {
        this.$message({
          showClose: true,
          message: 'money必填',
          type: 'error',
          duration: 1000,
        })
        // this.$message.error()
        return
      }
      if (!this.form.month) {
        this.$message({
          showClose: true,
          message: 'R值必填',
          type: 'error',
          duration: 1000,
        })
        // this.$message.error()
        return
      } else {
        if (this.levelData.length >= 1) {
          if (this.form.month != this.levelData[0].month) {
            this.$message({
              showClose: true,
              message: 'R值需保持一致',
              type: 'error',
              duration: 1000,
            })
            return
          }
        }
      }

      console.log(this.form)
      this.levelData.push({
        level: this.form.level,
        count: this.form.count,
        money: this.form.money,
        month: this.form.month,
      })
      ;(this.form.level = ''), (this.form.count = 1), (this.form.money = 1)
      this.changeLevel()
    },
    show() {
      console.log(this.query)
      // this.getReplenishSetByStore()
      this.form.profession = this.queryInfo.profession
      this.form.business = this.queryInfo.business
      this.form.store = this.queryInfo.store
      this.form.month = ''
      this.form.count = ''
      this.form.money = ''

      this.dialogVisible = true
      this.changeLevel()
    },
    hide() {
      this.changeLevel()
      this.dialogVisible = false
      this.$parent.getBuyerLevel()
      this.form = {
        profession: '',
        business: '',
        store: '',
        month: '',
        level: '',
        count: '',
        money: '',
      }
      this.levelData = []
      this.$refs.refDialog.resetFields()
      console.log('hide')
    },
    submit() {
      let isValid
      this.$refs.refDialog.validate((valid) => {
        isValid = valid
      })
      if (!isValid) return
      if (this.levelData.length < 1) {
        this.$message({
          showClose: true,
          message: '未添加卖家LEVEL数据',
          type: 'error',
          duration: 1000,
        })
        return
        // return this.$message.error('未添加level属性')
      }
      const formData = {
        store: this.form.store,
        business: this.form.business,
        month: this.form.month,
        levelData: this.levelData,
      }
      this.submitApi(formData)
    },
    async submitApi(form) {
      console.log(form)
      this.loading = true
      let { data, err } = await this.axiosApi(
        this.Desc.create_buyer_level,
        form
      )
      this.loading = false
      console.log(data)
      if (data && data.data.meta && data.data.meta.status === 200) {
        //
        // this.$parent.getBuyerLevel()

        this.hide()
      } else {
        // this.$message.error(err.response.data.message);
      }
      dealReturn(data, err)
    },
    // async getReplenishSetByStore() {
    //   let { data, err } = await this.axiosApi(
    //     this.Desc.replenishr_set_by_store,
    //     this.query
    //   )
    //   // console.log(data)
    //   if (data && data.status === 200) {
    //     console.log(data)
    //     // this.form = data.data.data
    //     this.setFrom(JSON.parse(JSON.stringify(data.data.data)))
    //   }

    //   dealReturn(data, err)
    // },
    // setFrom(data) {
    //   if (!data.id) {
    //     this.form.profession = this.query.profession
    //     this.form.business = this.query.business
    //     this.form.store = this.query.store
    //     return
    //   }
    //   if (data.id) {
    //     this.form = data
    //     this.form.start_time = this.form.start_time
    //       ? this.form.start_time
    //       : Desc.yestDate()
    //     let new_date = []
    //     if (data.tp_date) {
    //       for (const tpdate of data.tp_date) {
    //         new_date.push({ value: tpdate })
    //       }
    //     }
    //     this.form.tp_date = new_date
    //     return
    //   }
    // },
  },
  watch: {},
  filters: {},
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 700px;
  }
  .el-input {
    max-width: 200px;
  }
  label {
    font-size: 15px;
    // font-weight: 600;
  }
  .row {
    margin-top: 15px;
    .el-col {
      // height: 32px;
      line-height: 32px;
    }
  }
  .dialog-footer{
   margin-top: 20px;
  }
  .table-botton{
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/rfm/rfmBuyerLevel/dialog.vue